export const week = ['日', '一', '二', '三', '四', '五', '六'] as const;

export const _secondTime = 1000;
export const _minuteTime = 60 * _secondTime;
export const _hourTime = 60 * _minuteTime;
export const _dayTime = 24 * _hourTime;
export const _monthTime = 30 * _dayTime;
export const _yearTime = 12 * _monthTime;

export const pastTimeTypes = {
  year: '年前',
  month: '个月前',
  day: '天前',
  hour: '小时前',
  minute: '分钟前',
  just: '刚刚',
} as const;
